import axios from 'axios';

import { APIS_ENDPOINTS } from '../resources/api-constants';
import { getRefreshToken, updateAccessToken } from '../utility/tokenStorage';
import { storeValue } from '../utility/helpers';

let refreshRequestInFlight: Promise<any> | null = null;

async function performRefreshTokens() {
    const refresh = getRefreshToken();
    if (!refresh) {
        throw new Error('No refresh token');
    }

    // Same as other API calls: global axios + baseURL from setupInterceptorsTo(App.tsx)
    const { data } = await axios.post(
        APIS_ENDPOINTS.TOKEN_REFRESH,
        { refresh },
        {
            headers: {
                'Content-Type': 'application/json',
            },
            timeout: 10000,
        },
    );

    if (data.access) {
        updateAccessToken(data.access);
    }
    if (data.refresh) {
        storeValue('refreshToken', data.refresh);
    }

    return data;
}

export async function refreshTokens() {
    if (!refreshRequestInFlight) {
        refreshRequestInFlight = performRefreshTokens().finally(() => {
            refreshRequestInFlight = null;
        });
    }

    return refreshRequestInFlight;
}
